var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36169",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0H0V38H37V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.65 35.9326L27.097 26.2784C29.599 23.4871 31.136 19.7955 31.136 15.7333C31.135 7.0435 24.165 0 15.568 0C6.96999 0 0.000976562 7.0435 0.000976562 15.7333C0.000976562 24.4231 6.96999 31.4666 15.568 31.4666C19.282 31.4666 22.69 30.147 25.366 27.9531L34.956 37.645C35.423 38.118 36.182 38.118 36.649 37.645C36.76 37.534 36.848 37.401 36.909 37.254C36.969 37.107 37 36.949 37 36.789C37 36.63 36.969 36.472 36.909 36.325C36.849 36.178 36.761 36.044 36.65 35.9326ZM15.568 29.0459C8.29299 29.0459 2.396 23.0857 2.396 15.7333C2.396 8.3809 8.29299 2.4207 15.568 2.4207C22.842 2.4207 28.739 8.3809 28.739 15.7333C28.739 23.0857 22.842 29.0459 15.568 29.0459Z",
    fill: "white",
    fillOpacity: 0.37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7c42d7048c9efba8d9ad61ddc5457cb2.svg";
export { ForwardRef as ReactComponent };